import { CheckNotes, InspectionCase } from '../../inspection-cases';

export class ValvesPlumbingFittingsDto extends InspectionCase {
  sprinklerPipingAccordingSpec?: InspectionCase;
  controlStationsAccordingSpec?: InspectionCase;
  installationAccordingSpec?: InspectionCase;
  isControlBodyAccessible?: InspectionCase;
  valvesWiredToWarningHub?: InspectionCase;
  pressureDischargersAsRequired?: InspectionCase;
  pressureWatchesAsRequired?: InspectionCase;
}

export class ValvesPlumbingFittings extends ValvesPlumbingFittingsDto {
  constructor(
    data: ValvesPlumbingFittingsDto = {
      title: 'מגופים, צנרת ואביזרים'
    }
  ) {
    super(data);
    this.sprinklerPipingAccordingSpec = new InspectionCase({
      ...data.sprinklerPipingAccordingSpec,
      title: `צנרת המתזים תואמת לסוג המערכת בהתאם לדרישות התקן והתכנון`
    });
    this.controlStationsAccordingSpec = new InspectionCase({
      ...data.controlStationsAccordingSpec,
      title: `כל תחנות השליטה ,רטובות ,פעולה מקדימה הצפה Listed-  ומתאימות לדרישות התכנון והתקן`
    });
    this.installationAccordingSpec = new InspectionCase({
      ...data.installationAccordingSpec,
      title: `תמיכות ותליות נעשו בהתאם לדרישות התקן (מרחקי תליה, תמיכות תקניות/ מחושבות)`
    });
    this.isControlBodyAccessible = new InspectionCase({
      ...data.isControlBodyAccessible,
      title: `מגוף שליטה במקום נגיש ונוח להפעלה`
    });
    this.valvesWiredToWarningHub = new InspectionCase({
      ...data.valvesWiredToWarningHub,
      title: `כל המגופים מחווטים לרכזת התרעות`
    });
    this.pressureDischargersAsRequired = new InspectionCase({
      ...data.pressureDischargersAsRequired,
      title: `פורקי הלחץ מותקנים אחרי כל אל חוזר בתחנות ההפעלה`
    });
    this.pressureWatchesAsRequired = new InspectionCase({
      ...data.pressureWatchesAsRequired,
      title: `מותקנים שעני לחץ ע"ג תחנות השליטה`
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.sprinklerPipingAccordingSpec.isApplicable ||
        this.sprinklerPipingAccordingSpec.isPassed) &&
        (!this.controlStationsAccordingSpec.isApplicable ||
          this.controlStationsAccordingSpec.isPassed) &&
        (!this.installationAccordingSpec.isApplicable ||
          this.installationAccordingSpec.isPassed) &&
        (!this.isControlBodyAccessible.isApplicable ||
          this.isControlBodyAccessible.isPassed) &&
        (!this.valvesWiredToWarningHub.isApplicable ||
          this.valvesWiredToWarningHub.isPassed) &&
        (!this.pressureDischargersAsRequired.isApplicable ||
          this.pressureDischargersAsRequired.isPassed) &&
        (!this.pressureWatchesAsRequired.isApplicable ||
          this.pressureWatchesAsRequired.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.sprinklerPipingAccordingSpec.getNotes(),
      ...this.controlStationsAccordingSpec.getNotes(),
      ...this.installationAccordingSpec.getNotes(),
      ...this.isControlBodyAccessible.getNotes(),
      ...this.valvesWiredToWarningHub.getNotes(),
      ...this.pressureDischargersAsRequired.getNotes(),
      ...this.pressureWatchesAsRequired.getNotes()
    ];
  }
}
